var App = App || {};

App.Separators = (function ($) {
    "use strict";

    var separatedLists = $(".separated-list");

    function init() {
        var separatedElements = [];

        separatedLists.each(function () {
            var listItems = $(this).children("li")
            if (listItems.length) {
                separatedElements.push(listItems);
            }
        });

        applySeparatorsToGroup(separatedElements);

        $(window).resize(function () {
            applySeparatorsToGroup(separatedElements);
        })

        $('.offcanvas').on('shown.bs.offcanvas', function () {
            applySeparatorsToGroup(separatedElements);
        });

        $('.accordion').on('shown.bs.collapse', function () {
            applySeparatorsToGroup(separatedElements);
        }).on('hidden.bs.collapse', function () {
            applySeparatorsToGroup(separatedElements);
        });
    }

    function applySeparatorsToGroup(elementGroup) {
        if (elementGroup.length) {
            for (var i = 0; i < elementGroup.length; i++) {
                applySeparators(elementGroup[i])
            }
        }
    }

    function applySeparators(elements) {
        elements.removeClass("separated");
        if (elements.length) {
            var currentLineTop = 0,
                currentItemTop;
            elements.each(function () {
                currentItemTop = $(this).offset().top;
                if (currentItemTop == currentLineTop) {
                    $(this).addClass("separated"); //add separator only if this is not the first item on the line
                } else {
                    currentLineTop = currentItemTop;
                }
            });
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.Separators.init();
});